<script>
  import { intervalToDuration } from 'date-fns';

  import { Chart } from '@client/components/charts';

  import { CHART_TYPES } from '@client/enums';

  export let data = {};
  export let label = null;
  export let title = null;
  export let subtitle = null;
  export let height = 'auto';
  export let width = 'auto';

  const secondsToTimeFormat = (value) => {
    const duration = intervalToDuration({ start: 0, end: value * 1000 });

    let formatted = '';

    if (duration.hours) {
      formatted += duration.hours + 'hr ';
    }

    if (duration.minutes) {
      formatted += duration.minutes + 'm ';
    }

    if (duration.seconds) {
      formatted += duration.seconds + 's';
    }

    if (!formatted.length) {
      formatted += value + 's';
    }

    return formatted;
  };

  let options = {
    responsive: true,
    indexAxis: 'y',
    maxBarThickness: 12,
    title: {
      display: false
    },
    plugins: {
      legend: false
    },
    helpers: {
      tooltipHeaderFormatter: () => '',
      tooltipContentFormatter(content, lines, tooltip) {
        const [metricLabel, metricValue] = lines[0].shift().split(':');
        const item = document.createElement('div');

        item.className = 'item';

        const metric = document.createElement('div');
        const value = document.createElement('div');

        metric.className = 'metric';
        metric.innerHTML = metricLabel;

        value.className = 'value';
        value.innerHTML = secondsToTimeFormat(metricValue);

        const pair = document.createElement('div');

        pair.className = 'pair';

        pair.appendChild(metric);
        pair.appendChild(value);

        item.appendChild(pair);

        const preview = document.createElement('div');
        const image = document.createElement('img');
        image.src = `https://www.sendergen.com/v2/view/${data.hash}/${metricLabel}/thumbnail.png`;

        preview.appendChild(image);

        item.appendChild(preview);

        const border = document.createElement('div');

        border.style.position = 'absolute';
        border.style.left = '-1px';
        border.style.right = '-1px';
        border.style.top = '-1px';
        border.style.bottom = '-1px';
        border.style.border = '2px solid ' + tooltip.labelColors[0].backgroundColor;
        border.style.borderRadius = '3px';

        content.appendChild(item);
        content.appendChild(preview);
        content.appendChild(border);

        return content;
      }
    },
    scales: {
      y: {
        stacked: true,
        ticks: {
          autoSkip: false
        }
      },
      x: {
        beginAtZero: true,
        stacked: true,
        ticks: {
          callback: secondsToTimeFormat
        }
      }
    }
  };
</script>

<Chart type={CHART_TYPES.bar.id} bind:data bind:options bind:label bind:title bind:subtitle bind:height bind:width />
